import { call } from 'redux-saga/effects';
import { ICreateExtremeGridPayload } from '../entities/payloads';
import {
	IExtremeGridCreateSettings,
	IExtremeGridInstances,
	Events,
	IExtremeGridLoadOptions
} from '../entities/api';
import { createExtremeGrid, createExtremeGridOverride } from '../actions';
import { IBaseAction } from '@bimser/core';
import ExtremeGridInstance from './ExtremeGridInstance';
import { BaseState } from '../../../entities/BaseState';
import _set from 'lodash/set';
import _get from 'lodash/get';

declare global {
	interface Window {
		__store: any;
		ExtremeGridApi?: {
			instances: IExtremeGridInstances;
		};
	}
}

export class ExtremeGridAPI {
	static create(
		extremeGridOptions: ICreateExtremeGridPayload,
		settings?: IExtremeGridCreateSettings
	) {
		let action = null;
		if (settings?.override) {
			action = createExtremeGridOverride(extremeGridOptions);
		} else {
			action = createExtremeGrid(extremeGridOptions);
		}
		ExtremeGridAPI.dispatch(action);
	}

	static get(id: string) {
		const instancesPath = ['ExtremeGridApi', 'instances', id];
		const instance = _get(window, instancesPath);
		if (instance) {
			return instance;
		}
		_set(window, instancesPath, new ExtremeGridInstance(id));
		return _get(window, instancesPath);
	}

	static getProperties(id: string): any {
		const instancesPath = ['ExtremeGridApi', 'instances', id];
		const instance = _get(window, instancesPath);
		if (instance) {
			const state: BaseState = window.__store.getState();
			if (state.ExtremeGrid?.items.has(id)) {
				const extremeGrid: any = state.ExtremeGrid.items.get(id);
				return extremeGrid;
			}
		} else {
			return null;
		}
	}

	static toEndUser() {
		return {
			create: ExtremeGridAPI.create,
			get: ExtremeGridAPI.get,
			getProperties: ExtremeGridAPI.getProperties
		};
	}

	static emit(id: string, eventName: Events, data: any) {
		const instancesPath = ['ExtremeGridApi', 'instances', id];
		const instance = _get(window, instancesPath);
		if (instance) {
			instance.emit(eventName, data);
		}
	}

	static *loadDataSource(id: string, loadOptions: IExtremeGridLoadOptions) {
		const instancesPath = ['ExtremeGridApi', 'instances', id];
		const instance = _get(window, instancesPath);
		if (instance) {
			return yield call(
				{ context: instance.dataSource, fn: instance.dataSource.load },
				loadOptions
			);
		}
	}

	static getStore() {
		if (!window.__store) {
			throw new Error('Store cannot be null');
		}
		return window.__store;
	}
	static dispatch(action: IBaseAction<any>) {
		ExtremeGridAPI.getStore().dispatch(action);
	}
}

export default ExtremeGridAPI.toEndUser();
